import { useContext } from "react";
import { PageNewState, ComponentSearchDialogContext } from ".";

export const useComponentSearchDialogState = () => {
  const { pageState, setPageState } = useContext(ComponentSearchDialogContext);
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
